// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LazyImage from "@eisinc/MobiusOverrides/LazyImage";
import Tooltip from "@eisinc/MobiusOverrides/Tooltip/Tooltip";
import { mergeWithCss } from "@eisinc/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    CartLineModel,
    OrderLineModel,
    ProductModel,
    RequisitionModel,
} from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: RequisitionModel | CartLineModel | OrderLineModel | ProductModel;
    extendedStyles?: ProductImagesBadgesStyles;
    badges: {
        Image: string | undefined;
        DisplayName: string;
        Description: string;
    }[];
}

export interface ProductImagesBadgesStyles {
    triggererWrapper?: InjectableCss;
    tooltipWrapper?: InjectableCss;
}

export const productImagesBadgesStyles: ProductImagesBadgesStyles = {
    triggererWrapper: {
        css: css`
            max-width: 20px;
            max-height: 20px;
        `,
    },
    tooltipWrapper: {
        css: css`
            display: flex;
        `,
    },
};

const ProductImagesBadges = ({ product, extendedStyles, badges }: OwnProps) => {
    const [styles] = useState(() => mergeWithCss(productImagesBadgesStyles, extendedStyles));

    if (!product || !badges?.length) {
        return null;
    }

    return (
        <>
            {badges.map((badge, index) => {
                return (
                    badge.Image && (
                        <StyledWrapper key={`badge${index}`} {...styles.tooltipWrapper}>
                            <Tooltip
                                passAsChildren={true}
                                triggerComponent={
                                    <StyledWrapper {...styles.triggererWrapper}>
                                        <LazyImage
                                            width="18px"
                                            height="18px"
                                            src={badge.Image}
                                            altText={badge.DisplayName}
                                        />
                                    </StyledWrapper>
                                }
                            >
                                <StyledWrapper className="popup-content-wrapper">
                                    {/* eslint-disable react/no-danger */}
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                badge.DisplayName === "PROP_65_CANCER"
                                                    ? product.properties.prop65Text ||
                                                      (siteMessage("Custom_Prop65DefaultText") as string)
                                                    : badge.Description,
                                        }}
                                    ></div>
                                </StyledWrapper>
                            </Tooltip>
                        </StyledWrapper>
                    )
                );
            })}
        </>
    );
};

export default ProductImagesBadges;
